<template>
<popup :showFlag="showFlag"
       @onShowpop="onShowpop"
       :mask="false">
  <div class="slidewrap" v-if="meiyan&&meiyan[idx]">
    <div class="slidelist" v-for="item in meiyan[idx].val" :key="item.en">
      <div class="name">{{item.name}}</div>
      <mt-range v-model="meiyanVal[item.en]"
                :min="0"
                :max="item.max"
                :bar-height="5"
                @change="meiyanopr($event, item.en)">
        <div class="font32" slot="end">{{meiyanVal[item.en]}}</div>
      </mt-range>
    </div>
  </div>
  <div class="beautywrap">
    <div class="bscroll-div_H">
      <div  v-for="(item, index) in meiyan" :key="item.id">
        <div class="meiitem"
             :class="[idx===index?'mactive':'']"
             @click="idx=index">
          <div class="meiwrap">
            <img :src="[idx===index?item.asrc:item.src]" class="meiimg"/>
          </div>
          <span :class="[idx===index?'mactiveColor':'']">{{item.name}}</span>
        </div>
      </div>
    </div>
  </div>
  <duicuo @onCancel="onCancel"
          @onOk="onOk">
    <div class="opgroup">
      <div class="optxt" :class="[!beautyFlag?'actbeauty':'']" @click="isBeauty('0')">关闭美颜</div>
      <div class="optxt" :class="[beautyFlag?'actbeauty':'']" @click="isBeauty('1')">基础美颜</div>
    </div>
  </duicuo>
</popup>
</template>

<script>
import popup from '@/components/popup'
import duicuo from '@/components/duicuo/duicuo'
import { mapState } from 'vuex'
import { Range } from 'mint-ui'
export default {
  name: 'beauty',
  props: {
    showFlag: {
      default: false,
      type: Boolean
    },
    meiyanVal: {
      default: () => {},
      type: Object
    },
    beautyFlag: {
      default: true, // 默认美颜
      type: Boolean
    }
  },
  data () {
    return {
      idx: 0,
      meiyan: []
    }
  },
  computed: {
    ...mapState(['beauty_default', 'actiBol'])
  },
  activated () {
    if (!this.actiBol) {
      return
    }
    this.meiyan = this.beauty_default
  },
  methods: {
    onShowpop () {
      this.$emit('onBeautyClose')
    },
    meiyanopr (e, name) {
      const obj = {
        name,
        val: e
      }
      this.$emit('onDoMeiyan', obj)
    },
    onCancel () {
      this.initidx()
      this.$emit('onCancel')
    },
    isBeauty (beauty) {
      const bol = beauty === '1'
      if (this.beautyFlag === bol) {
        return
      }
      this.$emit('onIsMeiyan', bol)
    },
    onOk () {
      this.initidx()
      this.$emit('onNoneBeauty')
    },
    initidx () {
      this.idx = 0
    }
  },
  components: {
    popup,
    mtRange: Range,
    duicuo
  }
}
</script>

<style>
.slidewrap .mt-range-progress{
  background-color: #4710ED;
}
.slidewrap .mt-range{
  flex-grow: 1;
}
</style>

<style scoped>
.font32{
  font-size: 0.32rem;
}
.beautywrap{
  background-color: #F7F7F7;
  border-top-left-radius: .32rem;
  border-top-right-radius: .32rem;
  padding:.54rem .56rem;
  overflow: hidden;
  box-shadow: 0 0 .4rem rgba(0,0,0,0.2);
}
.bscroll-div_H{
  display: flex;
  display: -webkit-flex;
  box-sizing: border-box;
  overflow-x:auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.meiitem{
  flex-shrink: 0;
  text-align: center;
  font-size: .22rem;
  color:#303133;
  margin-right: .32rem;
}
.meiwrap{
  width:.8rem;
  height:.8rem;
  border-radius: .12rem;
  background-color: white;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: .16rem;
}
.meiimg{
  width:.48rem;
}
.mactiveColor{
  color:#4710ED;
}
.mactive .meiwrap{
  background-image:linear-gradient(to right,#8356FF,#4710ED);
}
.slidewrap{
  box-sizing: border-box;
  padding:0 .74rem;
}
.slidelist{
  margin-bottom: .4rem;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.name{
  font-size: .26rem;
  color:#303133;
  flex-shrink: 0;
  margin-right: 0.16rem;
}
.opgroup{
  font-size: .28rem;
  color:#303133;
  display: flex;
  display: -webkit-flex;
}
.optxt{
  padding:.1rem;
}
.optxt:first-child{
  margin-right: .64rem;
}
.actbeauty{
  color:#4710ED;
}
</style>
